<template>
<div>

  <div class="login" v-if="!isLogin && !isLoading">
    <div class="login__header">
      <div class="login__title">登录</div>
      <div class="login__sub">龙小主商户认证</div>
    </div>

    <div class="login__card">
      <van-field v-model="mobile" label="手机号" placeholder="请输入手机号" clearable />
      <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" clearable />
      <div class="login__actions">
        <van-button type="primary" block :loading="loading" @click="handleSubmit">登录授权</van-button>
      </div>
    </div>
  </div>
  <div v-if="isLogin && !isLoading">
    <div class="login__confirm">
      <div class="login__title">授权成功</div>
      <div class="login__sub">您已成功授权消息通知</div>
      <br />
      <div class="login__sub" @click="handleClose">退出关闭即可</div>
    </div>
  </div>
</div>
</template>

<script>
import { Notify } from 'vant'
import { login, loginByCode, fetchBizUser } from '@/api/lxz/biz'

export default {
  name: 'BizLoginPage',
  data() {
    return {
      mobile: '',
      password: '',
      loading: false,
      isLogin: false,
      authcode: '',
      isLoading: true
    }
  },
  created() {
    document.title = '商户端-登录授权'
    const code = this.$route.query.code
    if (code) {
      sessionStorage.setItem('bizusercode', code)
      this.authcode = code
    }
    this.fetchUser()
  },
  methods: {
    async fetchUser() {
      try {
        this.isLoading = true
        const res = await fetchBizUser()
        const ok = res.status === 200
        if (ok) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      } catch (error) {
        console.log('error', error)
        this.isLogin = false
      } finally {
        this.isLoading = false
      }
    },
    async handleloginByCode () {
      await loginByCode({ code: this.authcode }).then(res => {
        if (res.status === 200) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      })
    },
    async handleSubmit() {
      const username = String(this.mobile || '').trim()
      if (!username) {
        Notify({ message: '请输入手机号', type: 'danger' })
        return
      }
      const password = String(this.password || '').trim()
      if (!password) {
        Notify({ message: '请输入密码', type: 'danger' })
        return
      }
      this.loading = true
      try {
        const code = this.authcode || sessionStorage.getItem('bizusercode') || ''
        const res = await login({ form: { username, password, code } })
        const ok = res.status === 200
        const token = res.data.token || ''
        if (!ok || !token) {
          this.isLogin = false
          Notify({ message: (res && res.message) || '登录失败', type: 'danger' })
          return
        }
        this.isLogin = true
        localStorage.setItem('lxz-biz-token', token)
        Notify({ message: '登录成功', type: 'success' })
      } finally {
        this.loading = false
      }
    },

    handleClose() {
      localStorage.removeItem('lxz-biz-token')
      this.isLogin = false
    }
  }
}
</script>

<style scoped>
.login {
  padding-top: 200px;
  min-height: 100vh;
  background: #f5f7fa;
  padding-left:16px;
  padding-right: 16px;
  box-sizing: border-box;
}
.login__header {
  margin-bottom: 30px;
}
.login__title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
}
.login__sub {
  font-size: 13px;
  color: #888;
  margin-top: 6px;
}
.login__card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
}
.login__actions {
  margin-top: 14px;
}
.login__confirm {
  margin-top: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
